// extracted by mini-css-extract-plugin
export default {"container":"Header_container__1ODtl","left":"Header_left__0s6UL","right":"Header_right__4mE4Q","item":"Header_item__ILzr7","center":"Header_center__s+DUV"};